export default function ucfirst(str) {
	if (str.length === 0) {
		return str;
	}
	return str.charAt(0).toUpperCase() + str.slice(1);
}



// WEBPACK FOOTER //
// ./src/ucfirst.js